var ScheduleEditorComponent = new JS.Class(EditorComponent, {
  initialize: function(scheduleEditorDataSelector) {
    this.scheduleEditorDataSelector = scheduleEditorDataSelector;
  },

  getSaveData: function() {
    $(window).trigger('schedulePresubmit');
    var scheduleEditorData = $(this.scheduleEditorDataSelector).val();

    return {
      ScheduleEditor: scheduleEditorData,
    };
  },
});
